<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="100%"
    height="100%"
    viewBox="0 0 24 14"
  >
    <path
      stroke="currentColor"
      stroke-width="2"
      d="m22.707.71-11.002 11L.707.71"
    />
  </svg>
</template>
